import { useCallback } from 'react';
import './utils-ae044d92.js';
import './useConstant.esm.js';
import './encdec-fa8e1134.js';
import 'query-string';
import 'memoize-one';
import 'lodash.isequal';
import './stableUseObject-8397d805.js';
import useQueryParam from './useQueryParam.esm.js';
import 'react-router';
import useRouter from './useRouter.esm.js';

function useRouterQueryParam(name, defaultValue, qpEncoder, options) {
  if (qpEncoder === void 0) {
    qpEncoder = false;
  }

  if (options === void 0) {
    options = {};
  }

  var _useRouter = useRouter(),
      location = _useRouter.location,
      history = _useRouter.history;

  var setSearchStr = useCallback(function (nextQueryString, historyMethod) {
    if (historyMethod === void 0) {
      historyMethod = 'push';
    }
    /*
     * WARNING: do not be tempted to direcly use "location" from outer scope here,
     * since it changes at every render. This may cause an infinite render loop.
     */


    var url = history.location.pathname + "?" + nextQueryString;
    history[historyMethod](url);
  }, [history]);
  var proxied = useQueryParam(location.search, setSearchStr, name, defaultValue, qpEncoder, options);
  return proxied;
}

export default useRouterQueryParam;